module.exports = __webpack_public_path__ + "static/animation-walk-leg-2eb326e08b3fa71459e67be9d6b2d540.png";